// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2h5oF","select":"Header_select__1ZtwR","clinic":"Header_clinic__lCBAV"};